import { render } from "./PdfReportStandardSearch.vue?vue&type=template&id=1566d6f2"
import script from "./PdfReportStandardSearch.vue?vue&type=script&lang=js"
export * from "./PdfReportStandardSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__